"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectors = exports.entityReducer = exports.entityAdapter = exports.deleteOne = exports.createOne = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var map_keys_deep_lodash_1 = __importDefault(require("map-keys-deep-lodash"));
var normalizr_1 = require("normalizr");
var config_1 = __importDefault(require("../config"));
var createEntityReducer_1 = __importDefault(require("../createEntityReducer"));
var schema_1 = __importStar(require("./schema"));
function mapCreatedDamage(id, createDamage) {
    return {
        id: id,
        damageType: createDamage.damageType,
    };
}
/**
 * Create a new damage entity in an inspection.
 *
 * @param {string} inspectionId The ID of the inspection.
 * @param {CreateDamage} createDamage The details of the damage to create.
 */
function createOne(inspectionId, createDamage) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosResponse, id, createdEntity;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'post', url: "/inspections/".concat(inspectionId, "/damages"), data: (0, map_keys_deep_lodash_1.default)(createDamage, function (v, k) { return (0, lodash_1.snakeCase)(k); }) }))];
                case 1:
                    axiosResponse = _b.sent();
                    id = axiosResponse.data[schema_1.idAttribute];
                    createdEntity = mapCreatedDamage(id, createDamage);
                    return [2 /*return*/, __assign((_a = { axiosResponse: axiosResponse }, _a[schema_1.idAttribute] = id, _a), (0, normalizr_1.normalize)(createdEntity, schema_1.default))];
            }
        });
    });
}
exports.createOne = createOne;
/**
 * Delete a damage entity from an inspection.
 *
 * @param {string} inspectionId The ID of the inspeciton this damage belongs to.
 * @param {string} id The ID of the damage to delete.
 */
function deleteOne(inspectionId, id) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosResponse, result;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axios_1.default.request(__assign(__assign({}, config_1.default.axiosConfig), { method: 'delete', url: "/inspections/".concat(inspectionId, "/damages/").concat(id) }))];
                case 1:
                    axiosResponse = _c.sent();
                    result = (_a = {},
                        _a[schema_1.idAttribute] = id,
                        _a);
                    return [2 /*return*/, (__assign((_b = { axiosResponse: axiosResponse }, _b[schema_1.idAttribute] = id, _b), (0, normalizr_1.normalize)(result, schema_1.default)))];
            }
        });
    });
}
exports.deleteOne = deleteOne;
exports.entityAdapter = (0, toolkit_1.createEntityAdapter)({});
exports.entityReducer = (0, createEntityReducer_1.default)(schema_1.key, exports.entityAdapter);
exports.selectors = exports.entityAdapter.getSelectors(function (state) { return state[schema_1.key]; });
exports.default = (0, toolkit_1.createSlice)({
    name: schema_1.key,
    initialState: exports.entityAdapter.getInitialState({ entities: {}, ids: [] }),
    reducers: exports.entityReducer,
    extraReducers: function (builder) {
        builder.addCase('inspections/gotOne', function (state, action) {
            var entities = action.payload.entities;
            var damages = entities[schema_1.key];
            if (!(0, lodash_1.isEmpty)(damages)) {
                exports.entityAdapter.upsertMany(state, damages);
            }
        }).addCase('inspections/gotMany', function (state, action) {
            var entities = action.payload.entities;
            var damages = entities[schema_1.key];
            if (!(0, lodash_1.isEmpty)(damages)) {
                exports.entityAdapter.upsertMany(state, damages);
            }
        });
    },
});
//# sourceMappingURL=index.js.map